module.exports = __webpack_public_path__ + "static/media/IconAdmin.e1c364d4.svg";